export enum SubmissionState {
  Error,
  Success,
  Pending
}
